import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Card, Tabs, Typography } from 'antd';
import { 
  BookOutlined, 
  ToolOutlined, 
  ApartmentOutlined, 
  ExperimentOutlined, 
  BarChartOutlined 
} from '@ant-design/icons';

// Import feature components
import ExerciseLibrary from './Exercise/ExerciseLibrary';
import EquipmentLibrary from './Equipment/EquipmentLibrary';
import MuscleGroupsLibrary from './MuscleGroups/MuscleGroupsLibrary';
import AdaptationsLibrary from './Adaptations/AdaptationsLibrary';
import LibraryStatistics from './Statistics/LibraryStatistics';

const { Title } = Typography;

interface LibrariesRouterProps {
  defaultTab?: string;
}

const LibrariesRouter: React.FC<LibrariesRouterProps> = ({ defaultTab = 'exercises' }) => {
  const [activeTab, setActiveTab] = React.useState(defaultTab);

  const tabItems = [
    {
      key: 'exercises',
      label: (
        <span>
          <BookOutlined />
          Exercises
        </span>
      ),
      children: <ExerciseLibrary />,
    },
    {
      key: 'equipment',
      label: (
        <span>
          <ToolOutlined />
          Equipment
        </span>
      ),
      children: <EquipmentLibrary />,
    },
    {
      key: 'muscle-groups',
      label: (
        <span>
          <ApartmentOutlined />
          Muscle Groups
        </span>
      ),
      children: <MuscleGroupsLibrary />,
    },
    {
      key: 'adaptations',
      label: (
        <span>
          <ExperimentOutlined />
          Adaptations
        </span>
      ),
      children: <AdaptationsLibrary />,
    },
    {
      key: 'statistics',
      label: (
        <span>
          <BarChartOutlined />
          Statistics
        </span>
      ),
      children: <LibraryStatistics />,
    },
  ];

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ marginBottom: '24px' }}>
        <Title level={1} style={{ margin: 0 }}>
          Libraries Management
        </Title>
        <p style={{ margin: '8px 0 0 0', color: '#666' }}>
          Comprehensive management of exercises, equipment, muscle groups, and training adaptations
        </p>
      </div>
      
      <Card>
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          type="card"
          size="large"
          items={tabItems}
        />
      </Card>
    </div>
  );
};

// Export individual components for direct use
export { 
  ExerciseLibrary,
  EquipmentLibrary, 
  MuscleGroupsLibrary,
  AdaptationsLibrary,
  LibraryStatistics 
};

// Export shared components
export { default as LibraryTable } from './components/shared/LibraryTable';
export { default as FilterPanel } from './components/shared/FilterPanel';
export { default as StatsCard } from './components/shared/StatsCard';

// Export types
export * from './types';

// Export constants
export * from './constants';

// Export utilities
export * from './utils/filterUtils';

// Default export is the main router
export default LibrariesRouter; 